import { render } from "./AccountsInfoComponent.vue?vue&type=template&id=12632d9c&scoped=true"
import script from "./AccountsInfoComponent.vue?vue&type=script&lang=js"
export * from "./AccountsInfoComponent.vue?vue&type=script&lang=js"

import "./AccountsInfoComponent.vue?vue&type=style&index=0&id=12632d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12632d9c"]])

export default __exports__